module.exports = __webpack_public_path__ + "static/media/header-background.b2f33146.jpg";